import glamorous from "glamorous";

export const Container = glamorous.div({
  marginLeft: "0px",
  marginRight: "0px",
  padding: "0",
  paddingBottom: "20px",
  display: "inline-block",
  position: "relative",
  width: "100%",
  boxSizing: "border-box",
  backgroundColor: "rgb(255, 255, 255)",
  overflowX: "auto",
});

export const ScrollContainer = glamorous.div({
  margin: "0px",
  padding: "0",
  minWidth: "520px",
});

export const Header = glamorous.div({
  marginTop: "30px",
  marginLeft: "0px",
  paddingLeft: "0px",
  marginRight: "0px",
  lineHeight: "46px",
  boxSizing: "border-box",
  borderBottom: "1px solid rgb(194, 194, 194)",
  backgroundColor: "rgb(229, 230, 230)",
  textAlign: "center",
});

export const HeaderSpan = glamorous.span(({ content }) => ({
  boxSizing: "border-box",
  display: "inline-block",
  width: "20%",
  lineHeight: "26px",
  verticalAlign: "middle",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  cursor: "pointer",
  ":before": {
    paddingRight: "8px",
    margin: "0px",
    fontSize: "10px",
    content: content,
    color: "rgb(51, 51, 51)",
  },
}));

export const OrderList = glamorous.ul({
  marginTop: "0px",
  marginBottom: "0px",
  paddingBottom: "0px",
  marginLeft: "0px",
  marginRight: "0px",
  paddingLeft: "0",
  lineHeight: "46px",
  boxSizing: "border-box",
  "@media screen and (min-width: 992px)": {
    marginRight: "0px",
    marginLeft: "0px",
  },
});

export const OrderInfoLi = glamorous.li(({ isActive }) => ({
  zIndex: "1000",
  height: "100%",
  backgroundColor: isActive === true ? "rgb(244, 243, 243)" : "rgb(255, 255, 255)",
  borderBottom: "1px solid rgb(194, 194, 194)",
  listStyle: "none",
  textAlign: "center",
}));

export const PrimaryInfo = glamorous.div({
  cursor: "pointer",
  ":hover": {
    backgroundColor: "rgb(239, 240, 240)",
  },
});

export const InfoSpan = glamorous.span({
  verticalAlign: "top",
  boxSizing: "border-box",
  display: "inline-block",
  width: "20%",
  height: "46px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  fontSize: "14px",
});

export const ExpandContainer = glamorous.div(({ isActive }) => ({
  height: isActive === true ? "auto" : "0px",
  borderTop: "1px solid rgb(194, 194, 194)",
  width: "calc(100% - 20px)",
  marginRight: "20px",
}));

export const ProductList = glamorous.ul({
  position: "relative",
  padding: 0,
  margin: 0,
});

export const ProductLi = glamorous.li({
  listStyle: "none",
  paddingLeft: "0px",
  paddingRight: "0px",
  borderBottom: "1px solid rgb(194, 194, 194)",
});

export const InfoDiv = glamorous.div({
  width: "25%",
  display: "inline-block",
  textAlign: "center",
});

export const Label = glamorous.span({});

export const ProductInfo = glamorous.span({
  overflow: "hidden",
});

export const ProductHeader = glamorous.div({
  textAlign: "center",
  marginTop: "0px",
  marginLeft: "0px",
  marginRight: "0px",
  paddingLeft: "20px",
  paddingRight: "20px",
  lineHeight: "46px",
  boxSizing: "border-box",
  borderBottom: "1px solid rgb(194, 194, 194)",
  backgroundColor: "rgb(229, 230, 230)",
});

export const ProductHeaderSpan = glamorous.span({
  boxSizing: "border-box",
  display: "inline-block",
  width: "25%",
});

export const ExtraCosts = glamorous.div({
  textAlign: "right",
});

export const CostsDiv = glamorous.div({
  align: "right",
  margin: "0",
  width: "100%",
  display: "block",
  height: "26px",
});

export const CostLabel = glamorous.span({
  position: "relative",
  display: "inline-block",
  margin: "0",
  padding: "0",
});

export const CostInfo = glamorous.span({
  position: "relative",
  display: "inline-block",
  height: "26px",
  width: "15%",
  paddingLeft: "20px",
  paddingRight: "20px",
  lineHeight: "26px",
  minWidth: "100px",
});

export const Information = glamorous.div({
  padding: 0,
  marginLeft: "-20px",
  marginRight: "-20px",
  "@media screen and (min-width: 1025px)": {
    marginLeft: "-10px",
    marginRight: "-10px",
  },
});

export const Button = glamorous.button({
  border: "none",
  background: "none",
  color: "rgb(94, 106, 113)",
  textDecoration: "none",
  paddingTop: "19px",
  paddingLeft: "0",
  paddingRight: "20px",
  fontWeight: "normal",
  fontSize: "16px",
  lineHeight: "16px",
  verticalAlign: "middle",
  cursor: "pointer",
  boxSizing: "inherit",
  display: "block",
  marginLeft: "auto",
  marginRight: "auto",
  textAlign: "center",
  float: "right",
  ":hover": {
    color: "rgb(51, 51, 51)",
  },
  ":focus": {
    outline: "none",
  },
  ":after": {
    verticalAlign: "middle",
    display: "inline-block",
    fontSize: "14px",
    marginLeft: "8px",
    speak: "none",
    fontStyle: "normal",
    fontWeight: "normal",
    fontVariant: "normal",
    textTransform: "none",
    lineHeight: "18px",
    cursor: "pointer",
    content: "\\E903",
  },
});
